import React from "react";
import { AlertMessage } from "../../../../../../components/AlertMessage/AlertMessage";
import ElectricAIIcon from "./electric-ai.svg";
import styles from "./ElectricBanner.module.css";

interface ElectricBannerProps {
  memberName?: string;
  memberId?: string;
}

export const ElectricBanner: React.FC<ElectricBannerProps> = ({
  memberName = "{name}",
  memberId,
}) => {
  const iconComponent = (
    <img src={ElectricAIIcon} alt="Electric AI" width="40" height="40" />
  );

  return (
    <AlertMessage
      iconComponent={iconComponent}
      className={styles.electricBanner}
    >
      <div>
        <h3>Hardware and software access</h3>
        <p>
          If you're using Electric to manage {memberName}'s access to equipment
          or applications,{" "}
          <a
            href={`https://my.electric.ai/ship-laptop?hrisEmployeeId=${memberId}`}
            target="_blank"
          >
            head over to Electric
          </a>{" "}
          to revoke their access and track the status of any returning hardware.
        </p>
      </div>
    </AlertMessage>
  );
};

export default ElectricBanner;
